// src/components/Hero.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import image01 from '../assets/images/hero-li-yo-bg.jpg'; 
// import vBackImage from '../assets/images/gb-hero.jpg'; 

function Hero() {
  return (
    <section className="hero py-5 position-relative overflow-hidden"> {/* Removed bg-light */}
      {/* Dark Overlay for better text contrast and thematic feel */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.4)', // Semi-transparent dark overlay
          zIndex: 0.5, // Between background image and content
        }}
      ></div>
      <div className="container position-relative z-2 "> {/* Increased z-index to ensure content is above overlay */}
        <div className="row align-items-center justify-content-center text-light"> {/* Changed text-light to text-white for stronger contrast */}
          <div className="col-md-6 position-relative z-1 text-center">
            <h1 className="display-4 fw-bold">Engineering Excellence, Generation to Generation</h1>
            <p className="lead my-4">
              LIYO & SONS GROUP delivers innovative and sustainable civil engineering and construction solutions.
              We bring expertise and dedication to every project, ensuring quality and client satisfaction.
            </p>
            <div className="d-grid gap-2 d-md-block">
              <Link to="/services" className="btn btn-outline-warning btn-lg me-md-2 mb-2 mb-md-0">Explore Our Services</Link> {/* Changed to btn-primary for a more solid look */}
              <Link to="/projects" className="btn btn-outline-warning btn-lg">View Our Projects</Link>
            </div>
          </div>
        </div>
      </div>
      {/* Background Image Container */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${image01})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          opacity: 5, // Adjusted to a valid and more prominent opacity (0-1 range)
          zIndex: 0,
        }}
      >
      </div>
    </section>
  );
}

export default Hero;
